"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StyledText = _styledComponents["default"].p.withConfig({
  displayName: "Text__StyledText",
  componentId: "reuni5-0"
})(function (_ref) {
  var _theme$color$themeCol, _typography$typograph, _typography$typograph2, _typography$typograph3, _typography$typograph4;

  var theme = _ref.theme,
      themeColor = _ref.themeColor,
      typographyType = _ref.typographyType;
  return (0, _styledComponents.css)(["color:", ";padding:0;margin:0;font-size:", "rem;font-weight:", ";"], (_theme$color$themeCol = theme.color[themeColor]) !== null && _theme$color$themeCol !== void 0 ? _theme$color$themeCol : theme.color.text, (_typography$typograph = (_typography$typograph2 = _units.typography[typographyType]) === null || _typography$typograph2 === void 0 ? void 0 : _typography$typograph2.size) !== null && _typography$typograph !== void 0 ? _typography$typograph : _units.typography.body.size, (_typography$typograph3 = (_typography$typograph4 = _units.typography[typographyType]) === null || _typography$typograph4 === void 0 ? void 0 : _typography$typograph4.weight) !== null && _typography$typograph3 !== void 0 ? _typography$typograph3 : _units.typography.body.weight);
});
/**
 *
 * ### Text element component.

  Used to render a styled text string. The `element` prop will decide which HTML element the text will render as.
 */


var Text = function Text(_ref2) {
  var _typography$type$elem, _typography$type;

  var children = _ref2.children,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'body' : _ref2$type,
      _ref2$themeColor = _ref2.themeColor,
      themeColor = _ref2$themeColor === void 0 ? 'text' : _ref2$themeColor,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className;
  return /*#__PURE__*/_react["default"].createElement(StyledText, {
    as: (_typography$type$elem = (_typography$type = _units.typography[type]) === null || _typography$type === void 0 ? void 0 : _typography$type.element) !== null && _typography$type$elem !== void 0 ? _typography$type$elem : 'span',
    typographyType: type,
    themeColor: themeColor,
    className: className
  }, children);
};

var _default = Text;
exports["default"] = _default;